import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { HEALTH_PRO_MANUAL_URL, PATIENT_MANUAL_URL } from "@/constants/Constants.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type UserHelpProps = {
  isPractitioner?: boolean;
};

export const UserHelp: React.FC<UserHelpProps> = ({ isPractitioner = false }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const { data: config } = Queries.config.useSupportInfo({});

  return (
    <Card id="help-card" className={styles.container}>
      <CardHeader id="help-title" title={t("pages.account.userHelp.title")} />
      <CardContent>
        <Typography variant="body">
          <Button
            id="help-contact"
            data-action="account.help.email"
            variant="text"
            href={`mailto:${config?.supportEmail}`}
            target="_blank"
          >
            {t("pages.account.userHelp.contactUs", {
              supportEmail: config?.supportEmail,
            })}
          </Button>
          {` ${t("pages.account.userHelp.or")} `}
          <Button
            id="help-manual"
            data-action="account.help.open-manual"
            variant="text"
            href={isPractitioner ? HEALTH_PRO_MANUAL_URL : PATIENT_MANUAL_URL}
            target="_blank"
          >
            {t("pages.account.userHelp.userManual")}
          </Button>
        </Typography>
      </CardContent>
    </Card>
  );
};

const makeStyles = () => ({
  container: css``,
  questionIcon: css`
    height: 1em;
    width: 1em;
  `,
});
